import * as commonScripts from '../common'

const cmpTabs = {
  component: null,
  viewport: 0,
  resizeTimer: 0,

  init: function (element) {
    const _ = this
    // const uid = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8) + '--'
    const uid = '' // uid to be managed by the backend for now
    _.viewport = commonScripts.util.getViewportSize()

    window.addEventListener('resize', _.viewportSize, false)
    window.addEventListener('orientationchange', _.viewportSize, false)

    const dropdown = element.querySelector('.cmp-tabs__dropdown')
    const nav = element.querySelector('.cmp-tabs__nav')
    const tabs = nav.querySelectorAll('.cmp-tabs__tab')
    const content = element.querySelector('.cmp-tabs__content')
    const panels = commonScripts.util.getDirectChildren(content, '.cmp-tabs__panel')

    if (dropdown) {
      dropdown.addEventListener('click', (event) => {
        event.stopPropagation()

        dropdown.classList.toggle('open')
        nav.classList.toggle('vh')
      })
    }

    panels.forEach((panel) => {
      panel.setAttribute('aria-labelledby', uid + panel.getAttribute('aria-labelledby'))
      panel.id = uid + panel.id
    })

    tabs.forEach((tab) => {
      tab.setAttribute('aria-controls', uid + tab.getAttribute('aria-controls'))
      tab.id = uid + tab.id

      tab.addEventListener('click', (event) => {
        event.stopPropagation()

        if (dropdown) {
          dropdown.textContent = tab.textContent
          dropdown.classList.remove('open')
        }

        if (_.viewport.width < 768) {
          nav.classList.toggle('vh')
        }

        tabs.forEach((el) => {
          el.classList.remove('active')
        })
        tab.classList.add('active')

        panels.forEach((el) => {
          // set hidden attr based on whether or not tab.id and aria-labelledby match
          el.hidden = el.getAttribute('aria-labelledby') !== tab.id
        })
      })

      if (tab.getAttribute('aria-selected') === 'true') {
        if (dropdown) {
          dropdown.textContent = tab.textContent
        }
        tab.classList.add('active')
        setTimeout(() => {
          tab.classList.add(':focus')
        }, 100)
      }
    })       
  },

  viewportSize: function (event) {
    const _ = this
    clearTimeout(_.resizeTimer)
    _.resizeTimer = setTimeout(() => {
      _.viewport = commonScripts.util.getViewportSize()
    }, 500)
  }
}

export default cmpTabs
